<div class="navbar">
  <div class="header">
    <div class="content">
      <div class="left">
        <div class="logo"></div>
      </div>

      <div class="mid">
        <!-- <button matButton epg-button epg-button-icon shape="text" class="portal-bar-selector portal-bar-selector-button">
  <div class="header">
    <div class="content">
      <div class="left">
        <div class="logo"></div>
      </div>

      <div class="mid">
        <button matButton epg-button epg-button-icon shape="text" class="portal-bar-selector portal-bar-selector-button">
                        <span class="far fa-grid"></span>
                        <span class>CDH</span>
                        <span></span>
                        <span class="fas fa-chevron-down"></span>
                    </button>

                    <button matButton epg-button epg-button-icon shape="text" class="portal-bar-selector portal-bar-selector-button">
                        <span class="far fa-folder-user"></span>
                        <span class>1234</span>
                        <p class="sub-item">Customer name</p>
                        <span></span>
                        <span class="fas fa-chevron-down"></span>
                    </button> -->
      </div>

      <div class="right">
        <!-- <button epg-button epg-button-icon shape="text" class="portal-button">
                    <span class="fas fa-download epg-icon"></span>
                </button>
                <button epg-button epg-button-icon shape="text" class="portal-button">
                    <span class="far fa-house epg-icon"></span>
                </button>
                <button epg-button epg-button-icon shape="text" class="portal-button">
                    <span class="far fa-question epg-icon"></span>
                </button> -->

        @if (!isDownloading()) {
          <button
            epg-icon-button
            [matMenuTriggerFor]="menu"
            aria-label="Download"
          >
            <span class="fas fa-download"></span>
          </button>
        }
        @if (isDownloading()) {
          <button
            epg-icon-button
            class="loading-background-color"
            [matMenuTriggerFor]="menu"
            aria-label="Downloading"
          >
            <span class="fas fa-spinner-third fa-spin"></span>
          </button>
        }
        <mat-menu #menu="matMenu" class="export-menu">
          <button mat-menu-item (click)="onDownload()">
            <mat-icon>file_download</mat-icon>
            Export XLSX
          </button>
        </mat-menu>

        <epg-user-menu-navigation
          [isOpen]="isOpenSmallOverlay"
          (onToggleOverlayClick)="toggleOverlayBackdrop($event)"
          class="user-menu-large-view"
        >
          <epg-user-profile-info>
            <!-- <h2>{{ userProfile()?.name }}</h2>
            <p class="email">{{ userProfile()?.email }}</p> -->
            <h2>Ryan Antenor</h2>
            <p class="email">johndoe.example.com</p>
          </epg-user-profile-info>
          <!-- TODO - That will be comment until the funcionality of language selector its working -->
          <!-- <epg-language-selector>
            <cdk-accordion>
              <cdk-accordion-item #accordionItem="cdkAccordionItem">
                <button
                  epg-button
                  epg-button-icon
                  [shape]="'text'"
                  class="button-option"
                  (click)="accordionItem.toggle()"
                  tabindex="0"
                  id="accordion-header-0"
                  [attr.aria-expanded]="accordionItem.expanded"
                  aria-controls="accordion-body-0"
                >
                  <span>English</span>
                  <span class="fas fa-chevron-down"></span>
                </button>
                @if(accordionItem.expanded) {
                <div
                  class="language-selector"
                  [style.display]="accordionItem.expanded ? '' : 'none'"
                  id="accordion-body-0"
                  aria-labelledby="accordion-header-0"
                >
                  <button epg-button [shape]="'text'" class="language-item">
                    Test
                  </button>
                  <button epg-button [shape]="'text'" class="language-item">
                    Test
                  </button>
                  <button epg-button [shape]="'text'" class="language-item">
                    Test
                  </button>
                </div>
                }
              </cdk-accordion-item>
            </cdk-accordion>

          </epg-language-selector> -->
          <epg-user-menu-selection>
            <button mat-button class="button-option">
              <span matButtonIcon class="far fa-pencil"></span>
              Update profile
            </button>

            <button mat-button class="button-option">
              <span matButtonIcon class="far fa-cog"></span>
              Parameters
            </button>

            <div class="card-footer">
              <button mat-button class="button-option">
                <span matButtonIcon class="far fa-sign-out-alt"></span>
                Logout
              </button>
            </div>
          </epg-user-menu-selection>
        </epg-user-menu-navigation>

        <epg-user-menu-navigation-fullscreen
          [isOpen]="isOpen"
          (onToggleOverlayClick)="toggleOverlay($event)"
          class="user-menu-small-view"
        >
          <epg-user-profile-info>
            <h2>{{ userProfile()?.name }}</h2>
            <p class="email">{{ userProfile()?.email }}</p>
          </epg-user-profile-info>
          <!-- TODO - That will be comment until the funcionality of language selector its working -->
          <!-- <epg-language-selector>
            <cdk-accordion>
              <cdk-accordion-item #accordionItem="cdkAccordionItem">
                <button
                  epg-button
                  epg-button-icon
                  [shape]="'text'"
                  class="button-option"
                  (click)="accordionItem.toggle()"
                  tabindex="0"
                  id="accordion-header-0"
                  [attr.aria-expanded]="accordionItem.expanded"
                  aria-controls="accordion-body-0"
                >
                  <span>English</span>
                  <span class="fas fa-chevron-down"></span>
                </button>
                @if(accordionItem.expanded) {
                <div
                  class="language-selector"
                  [style.display]="accordionItem.expanded ? '' : 'none'"
                  id="accordion-body-0"
                  aria-labelledby="accordion-header-0"
                >
                  <button epg-button [shape]="'text'" class="language-item">
                    Test
                  </button>
                  <button epg-button [shape]="'text'" class="language-item">
                    Test
                  </button>
                  <button epg-button [shape]="'text'" class="language-item">
                    Test
                  </button>
                </div>
                }
              </cdk-accordion-item>
            </cdk-accordion>
          </epg-language-selector> -->
          <epg-user-menu-selection>
            <button mat-button class="button-option">
              <span matButtonIcon class="far fa-pencil"></span>
              Update profile
            </button>

            <button mat-button class="button-option">
              <span matButtonIcon class="far fa-cog"></span>
              Parameters
            </button>

            <div class="card-footer">
              <button mat-button class="button-option">
                <span matButtonIcon class="far fa-sign-out-alt"></span>
                Logout
              </button>
            </div>
          </epg-user-menu-selection>
        </epg-user-menu-navigation-fullscreen>
      </div>
    </div>
  </div>
</div>
